import { Box, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    flex: 1, // grow to fill the viewport height so the results panel can reach the bottom
    paddingBottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
    },

    // Pagination sits on the page background here — keep the number boxes white (the active page
    // still gets the purple border from the shared CustomPagination style).
    '& .MuiPaginationItem-root': {
      backgroundColor: palette.white,
    },

    '& .Mui-selected': {
      backgroundColor: `${palette.white} !important`,
    },
  };
});

export const PageTitle = styled('h1')({
  margin: 0,
  fontSize: '28px',
  fontWeight: 700,
  color: palette.text.header,
});

export const SearchContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    minHeight: '100px',
    borderRadius: '32px',
    padding: '32px',
    backgroundColor: palette.white,
    display: 'flex',
    alignItems: 'center',
    gap: '32px',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '16px',
      minHeight: 'auto',
    },
  };
});

// White panel wrapping the results, like `CandidatesListBlock` — cards (with their grey
// border) sit inside it, standing out against the grey page background on desktop.
export const ResultsPanel = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    flex: 1, // fill remaining space under the title/search so the panel reaches the screen bottom
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',
    padding: '24px',
    position: 'relative',

    [theme.breakpoints.down('tablet')]: {
      padding: '16px',
      borderRadius: '16px',
    },
  };
});

// Fixed column counts that all divide 12 (page size), so the last row is never ragged on
// wide screens — 4 → 3 rows, 3 → 4 rows, 2 → 6 rows.
export const Grid = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    // minmax(0, 1fr) so columns can shrink below their content width — plain 1fr (= minmax(auto,
    // 1fr)) lets a wide card push the track past its share and overflow the panel (~1200–1411px).
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '16px',

    [theme.breakpoints.down('desktop')]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },

    [theme.breakpoints.down('laptop')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
});

// Fills the results panel and centres the spinner both ways during the initial load.
export const SpinnerWrapper = styled(Box)({
  flex: 1,
  minHeight: '240px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const EmptyText = styled('p')({
  margin: 0,
  fontSize: '15px',
  color: '#6B7280',
  textAlign: 'center',
  padding: '24px 0',
});
